import React from "react";
import "./scroll.css";
import { trackEvent } from "../../utils/trackEvent";

const Whatsapp = () => {
  return (
    <a
      className="whatsapp-fab"
      href="https://wa.me/966544688761"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
      onClick={() => trackEvent("whatsapp_click")}
    >
      <span className="whatsapp-fab__shine" aria-hidden="true" />
      <span className="whatsapp-fab__inner">
        <i className="fab fa-whatsapp whatsapp-fab__icon" aria-hidden="true" />
      </span>
    </a>
  );
};

export default Whatsapp;
